export const EXTERNAL_ID_ISSUER_SGI = 'SGI';
